import { useState, useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import DetailsView from "../../../components/Views/DetailsView/DetailsView";
import { useHistory, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import InputFrames from "../../../components/Frames/InputFrames";
import { actions as commonActions } from "../../../store/actions/index";
import { actions } from "../state/actions";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import { useTranslation } from "react-i18next";
import SurveyForm from "./SurveyForm";
import { getMonthAndYearFromDate } from "../../../utils/utils";

const SurveyEdit = () => {
  const history = useHistory();
  const urlParams = useParams();
  const dispatch = useDispatch();
  const commonState = useSelector((state) => state.common);
  const state = useSelector((state) => state.posSurvey);
  const { t } = useTranslation();
  const pageName = "Pos Survey";
  const menuState = useSelector((state) => state.menus);
  const [isReadOnly, setIsReadOnly] = useState(false);
  const [surveyInfo, setSurveyInfo] = useState({
    SurveyModality: "",
    SurveyIsBuyerThere: "",
    SurveyModalityReported: "",
    SurveyMainModality: "",
    SurveyEZDRepName: "",
    SurveyIsExisting: "",
    RepresentativePresent: ""
  });
  
  const [errorInfo, setErrorInfo] = useState({
    error: "",
    status: false,
  });

  const [errorMessage,setErrorMessage] = useState({
    error: "",
    status: false,
  });


  const [isDisabled, setIsDisabled] = useState(true);

  useEffect(() => {
    const readonly = menuState?.data?.readOnly?.[pageName] === 1 ? true : false;
    setIsReadOnly(readonly);
  }, [menuState?.data?.readOnly?.[pageName]]);

  useEffect(() => {
    dispatch(commonActions.setLoading(true));
    dispatch(actions.getSurveyInfoById(urlParams.id));

    if (commonState.redirect) {
      dispatch(commonActions.setRedirect(false));
      history.push("/survey");
    }
  }, [commonState.redirect]);

  const resetFields = (resetFor) => {
    const fieldsMapping = {
      SurveyIsExisting: ['SurveyIsBuyerThere', 'SurveyModalityReported', 'RepresentativePresent', 'RepresentativePresent', 'SurveyEZDRepName'],
      SurveyIsBuyerThere: ['SurveyModalityReported', 'RepresentativePresent', 'RepresentativePresent', 'SurveyEZDRepName'],
      SurveyModalityReported: ['SurveyEZDRepName'],
      RepresentativePresent: ['SurveyEZDRepName']
    }

    const resetableKeys = fieldsMapping[resetFor]
                              .reduce((acc, value) => {  
                                  acc[value] = "";
                                  return acc;
                              }, {});

    setSurveyInfo((previousState) => ({
      ...previousState,
      ...resetableKeys,
    }));
  }

  const handleChangeField = ({ target: { name, value } }) => {
    //   dispatch(actions.setEditForm({ name, value }));
    setSurveyInfo((previousState) => ({
      ...previousState,
      [name]: value,
    }));
    if(name=="SurveyMainModality"){
      setErrorInfo((previousState) => ({
        ...previousState,
        SurveyMainModality: "",
      }));
    }
      if(name=="SurveyIsExisting"){
       setErrorMessage((previousState) => ({
          ...previousState,
          error: "",
          status: false,
        }));
      if (surveyInfo.SurveyIsExisting === 0) {
        resetFields("SurveyIsExisting");
      }
    }
    if(name=="SurveyModalityReported"){
        setErrorMessage((previousState) => ({
          ...previousState,
          error: "",
          status: false,
        }));
      
    }

    if (name == "SurveyIsBuyerThere" && surveyInfo.SurveyIsExisting === 1) {
      setErrorInfo((previousState) => ({
        ...previousState,
        SurveyIsBuyerThere: "",
      }));
      if (value === 0) {
        resetFields("SurveyIsBuyerThere");
      }
    }

    if (name == "SurveyModalityReported") {
      setErrorInfo((previousState) => ({
        ...previousState,
        SurveyModalityReported: "",
      }));
      if (surveyInfo.SurveyModalityReported === 0) {
        resetFields("SurveyModalityReported");
      }
    }

    if (name == "RepresentativePresent") {
      setErrorInfo((previousState) => ({
        ...previousState,
        RepresentativePresent: "",
      }));
      if (value === 0) {
        resetFields("RepresentativePresent");
      }
      return;
    }

    if (name == "SurveyEZDRepName") {
      setErrorInfo((previousState) => ({
        ...previousState,
        SurveyEZDRepName: "",
      }));
      return;
    }
    setIsDisabled(false);
  };
  
  const handleFormSubmit = () => {
    if (surveyInfo.SurveyIsExisting === "") {
      setErrorInfo((previousState) => ({
        ...previousState,
        error: "Is Existing is required",
        status: true,
      }));
      return;
    }

    if (surveyInfo.SurveyIsExisting === 1 && !([0,1].includes(surveyInfo?.SurveyIsBuyerThere))) {
      setErrorInfo((previousState) => ({
        ...previousState,
        SurveyIsBuyerThere: "Buyer Is there is required",
      }));
      return;
    }

    if(surveyInfo.SurveyModalityReported === "M"){
     if (surveyInfo.SurveyMainModality === "") {
      setErrorInfo((previousState) => ({
         ...previousState,
         SurveyMainModality: "Main Modality is required"
       }));
       return;
     }
    }

    if (surveyInfo.SurveyIsBuyerThere === 1 && surveyInfo.SurveyModalityReported === "") {
      setErrorInfo((previousState) => ({
        ...previousState,
        SurveyModalityReported: "Modality Reported is required",
      }));
      // return;
    }

    if (surveyInfo.SurveyIsBuyerThere === 1 && surveyInfo.RepresentativePresent === "") {
      setErrorInfo((previousState) => ({
        ...previousState,
        RepresentativePresent: "Representative Present is required",
      }));
      return;
    }

    if (surveyInfo.SurveyIsBuyerThere === 1 && surveyInfo.RepresentativePresent === 1 && surveyInfo.SurveyEZDRepName === "") {
      setErrorInfo((previousState) => ({
        ...previousState,
        SurveyEZDRepName: "Representative Name is required",
      }));
      return;
    }

    const surveyInfoPayload = {...surveyInfo};
    delete surveyInfoPayload?.RepresentativePresent;

    const payload = {
      ...surveyInfoPayload,
      POS_EZDSK: state?.surveyEdit?.POS_EZDSK,
      SurveySK: state?.surveyEdit?.SurveySK,
      SurveyPOSISPOSCode: state?.surveyEdit?.SurveyPOSISPOSCode,
      SurveyPOSLegalName: state?.surveyEdit?.SurveyPOSLegalName,
      SurveyEZDPOSCode: state?.surveyEdit?.SurveyEZDPOSCode,
      POSStreet: state.surveyEdit?.POSStreet,
      SurveyStateDescription: state?.surveyEdit?.SurveyStateDescription,
      SurveyDate: getMonthAndYearFromDate(state?.surveyEdit?.SurveyCreatedOn, "es"),
      userId: commonState.userInfo.principalName,
      countrySk: commonState.userInfo.countrySk,
    };
    dispatch(actions.submitPosSurvey(payload));
    dispatch(commonActions.setUpdated(true));
    
  };

  const handleFormCancel = () => {
    history.push("/survey");
  };
  return (
    <DetailsView
      heading="Edit Survey Pos"
      onSubmit={handleFormSubmit}
      onCancel={handleFormCancel}
      isDisabled={isDisabled}
    >
      {state?.surveyEdit &&
      Object.keys(state.surveyEdit).length > 0 &&
      !commonState.loading ? (
        <form className="details__view__body__form">
          <>
            <Grid container spacing={4}>
              <Grid item sm={4}>
                <TextField
                  variant="outlined"
                  name="POSPOSISPOSCode"
                  label={t(`Pos Code`)}
                  size="small"
                  InputLabelProps={{ shrink: true }}
                  value={state.surveyEdit?.SurveyPOSISPOSCode}
                  disabled
                />
              </Grid>
              <Grid item sm={4}>
                <TextField
                  variant="outlined"
                  name="SurveyEZDPOSCode"
                  label={t(`EZD Pos Code`)}
                  size="small"
                  InputLabelProps={{ shrink: true }}
                  value={state.surveyEdit?.SurveyEZDPOSCode}
                  disabled
                />
              </Grid>

              <Grid item sm={4}>
                <TextField
                  variant="outlined"
                  name="SurveyPOSLegalName"
                  label={t(`Legal Name`)}
                  size="small"
                  InputLabelProps={{ shrink: true }}
                  value={state.surveyEdit?.SurveyPOSLegalName}
                  disabled
                />
              </Grid>
              <Grid item sm={4}>
                <TextField
                  variant="outlined"
                  name="POSStreet"
                  label={t(`Street`)}
                  size="small"
                  InputLabelProps={{ shrink: true }}
                  value={state.surveyEdit?.POSStreet}
                  disabled
                />
              </Grid>
              <Grid item sm={4}>
                <TextField
                  variant="outlined"
                  name="State"
                  label={t(`State`)}
                  size="small"
                  InputLabelProps={{ shrink: true }}
                  value={state.surveyEdit?.SurveyStateDescription || ""}
                  disabled
                />
              </Grid>
              <Grid item sm={4}>
                <TextField
                  variant="outlined"
                  name="SurveyMonthlyVolume"
                  value={state.surveyEdit?.SurveyMonthlyVolume || 0}
                  label={t(`Volume`)}
                  type="number"
                  disabled
                  inputProps={{ min: 0 }}
                  onChange={handleChangeField}
                  InputLabelProps={{ shrink: true }}
                  size="small"
                />
              </Grid>
              <Grid item sm={4}>
                <TextField
                  variant="outlined"
                  value={state.surveyEdit?.SurveyModality || ""}
                  name="SurveyModality"
                  InputLabelProps={{ shrink: true }}
                  label={t(`Modality`)}
                  size="small"
                  disabled
                />
              </Grid>
              <Grid item sm={4}>
                <TextField
                  select
                  variant="outlined"
                  style={{ minWidth: 220 }}
                  value={surveyInfo.SurveyIsExisting}
                  name="SurveyIsExisting"
                  onChange={handleChangeField}
                  InputLabelProps={{ shrink: true }}
                  label={t(`Is Existing`)}
                  size="small"
                  disabled={isReadOnly}
                  error={errorInfo.status ? true : false}
                  helperText={t(errorInfo.error)}
                >
                  <MenuItem value={""}></MenuItem>
                  <MenuItem value={1}>Yes</MenuItem>
                  <MenuItem value={0}>No</MenuItem>
                </TextField>
              </Grid>
            </Grid>
            {surveyInfo.SurveyIsExisting === 1 && (
              <SurveyForm
                surveyInfo={surveyInfo}
                surveyDetails={state?.surveyEdit}
                handleChangeField={handleChangeField}
                readOnly={isReadOnly}
                errorMessage={errorMessage}
                errorInfo={errorInfo}
              />
            )}
          </>
        </form>
      ) : (
        <InputFrames />
      )}
    </DetailsView>
  );
};

export default SurveyEdit;
